import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { OverallTemperatureAdheranceService } from "./service/overall-temperature-adherance.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: "widget-overall-temperature-adherance",
  templateUrl: "./widget-overall-temperature-adherance.component.html",
  styleUrls: ["./widget-overall-temperature-adherance.component.scss"],
  providers: [OverallTemperatureAdheranceService]
})
export class WidgetOverallTemperatureAdheranceComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;

  highcharts: typeof Highcharts = Highcharts;
  chartOptions;

  constructor(
    private translateService: TranslateService,
    private dataService: OverallTemperatureAdheranceService
  ) { }

  ngAfterViewInit() {
    this.getOverallTemperatureAdherance();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getOverallTemperatureAdherance();
    }
  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.TRANSFER.REASON_FOR_FAILURE")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
  }

  getOverallTemperatureAdherance() {
    const params = {};
    this.dataService
      .getOverallTemperatureAdherance(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(chartData => {
        this.chartOptions = this.dataService.createChart(
          chartData,
          this.OPTIONS
        );
      });
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
